export default "<style>\n  enum--field\n  {\n    \n  }\n\n  [] > select\n  {\n    min-width: 10em;\n  }\n  \n\n</style>";